import React, { useEffect, useState, useRef } from 'react';
import {
    message, Input, Modal, Space, Typography, Row, Col, Select, Button,
    Alert, Tag, InputNumber, Grid, Upload
} from 'antd';
import {
    DollarOutlined, SolutionOutlined, SwapOutlined, ThunderboltOutlined, UserOutlined,
    PieChartOutlined, IdcardOutlined, PrinterOutlined, CameraOutlined, DeleteOutlined
} from '@ant-design/icons';
import { useCrearVenta } from '../../../hooks/useVentas';
import { useClientes } from '../../../hooks/useClientes';
import { pdf } from '@react-pdf/renderer';
import { FacturaFormal } from '../FacturaFormal';
import { generarTicketBluetooth } from '../../../utils/impresionBluetooth';
import axios from 'axios';
import { useAuth } from '../../../aws/AuthContext';

const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const OPCIONES_BANCOS = [
    { id: 'Nequi', label: 'Nequi', color: '#e11d48', bg: '#fff1f2', border: '#fda4af', icon: '📱' },
    { id: 'Daviplata', label: 'Daviplata', color: '#dc2626', bg: '#fef2f2', border: '#fca5a5', icon: '🔴' },
    { id: 'Bancolombia', label: 'Bancolombia', color: '#d97706', bg: '#fffbeb', border: '#fcd34d', icon: '🟡' },
    { id: 'Datafono', label: 'Datáfono', color: '#2563eb', bg: '#eff6ff', border: '#93c5fd', icon: '💳' },
    { id: 'Llave Bre-B', label: 'Llave Bre-B', color: '#7c3aed', bg: '#f5f3ff', border: '#c4b5fd', icon: '🔑' },
    { id: 'Transferencia Bancaria', label: 'Transf. Banco', color: '#059669', bg: '#ecfdf5', border: '#6ee7b7', icon: '🏦' },
];

const ModalCobrar = ({ digitoComprobante, setDigitoComprobante, clienteSeleccionado, cajaActiva, sumaTotalGlobal, carrito, setDatosImpresion, subtotal, impuestos, isModalOpen, totalArticulos, totalDescuento, handlePrint, setIsModalOpen, setClienteSeleccionado, ventaActivaEnEspera, deleteEspera, vaciarCarrito, setIsModalClienteOpen, config, setListaPrecioActiva, ordenIdOrigen }) => {

    const { getJwtToken } = useAuth();
    const screens = useBreakpoint();
    const isMobile = screens.md === false;

    const { mutate: ejecutarVenta, isLoading: procesandoVenta } = useCrearVenta();

    const [metodoPagoActivo, setMetodoPagoActivo] = useState('Efectivo');
    const [bancoDestino, setBancoDestino] = useState('Nequi');
    const [imprimirTicket, setImprimirTicket] = useState(true);
    const [efectivo, setEfectivo] = useState(null);
    const [montoMixtoEfectivo, setMontoMixtoEfectivo] = useState(null);
    const [abonoInicial, setAbonoInicial] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [comprobante, setComprobante] = useState(null);

    const inputEfectivoRef = useRef(null);

    const { data: clientesDB = [] } = useClientes();
    const clientesDBSeguro = Array.isArray(clientesDB) ? clientesDB : [];

    const datosTotales = { subtotal, impuestos, total: sumaTotalGlobal, totalArticulos, totalDescuento };
    const cambioEfectivo = efectivo && efectivo > sumaTotalGlobal ? efectivo - sumaTotalGlobal : 0;
    const montoMixtoCalculado = montoMixtoEfectivo ? sumaTotalGlobal - montoMixtoEfectivo : sumaTotalGlobal;

    useEffect(() => {
        if (isModalOpen && metodoPagoActivo === 'Efectivo') {
            setTimeout(() => {
                inputEfectivoRef.current?.focus();
            }, 100);
        }
    }, [isModalOpen, metodoPagoActivo]);

    useEffect(() => {
        const guardado = localStorage.getItem('imprimir_ticket_defecto');
        setImprimirTicket(guardado !== null ? JSON.parse(guardado) : true);
    }, []);

    const cobrarVenta = () => {

        if (isSubmitting || procesandoVenta) return; // Barrera para evitar doble cobro

        let efFijo = 0;
        let trFijo = 0;

        if (metodoPagoActivo === 'Mixto') {
            efFijo = montoMixtoEfectivo || 0;
            if (efFijo <= 0 || efFijo >= sumaTotalGlobal) {
                return message.warning("En pago mixto, el efectivo debe ser mayor a $0 y menor al Total.");
            }
            trFijo = sumaTotalGlobal - efFijo;
        } else if (metodoPagoActivo === 'Efectivo') {
            efFijo = sumaTotalGlobal;
            if (!efectivo || efectivo < sumaTotalGlobal) {
                return message.warning(`Debes recibir al menos $${sumaTotalGlobal.toLocaleString('es-CO')} en efectivo.`);
            }
        } else if (metodoPagoActivo === 'Transferencia') {
            trFijo = sumaTotalGlobal;
        } else if (metodoPagoActivo === 'Credito') {
            efFijo = abonoInicial || 0;
            if (efFijo >= sumaTotalGlobal) {
                return message.warning("El abono no puede cubrir todo el total. Usa 'Efectivo' en ese caso.");
            }
            trFijo = 0;
            if (!clienteSeleccionado || clienteSeleccionado === 'DEFAULT' || clienteSeleccionado?.id === 'DEFAULT') {
                return message.error("⚠️ DEBES SELECCIONAR UN CLIENTE PARA FIAR.");
            }
        }

        setIsSubmitting(true);

        let clienteIdFinal = null;
        if (clienteSeleccionado) {
            if (typeof clienteSeleccionado === 'object') {
                clienteIdFinal = (clienteSeleccionado.id === 'DEFAULT' || !clienteSeleccionado.id) ? null : clienteSeleccionado.id;
            } else if (typeof clienteSeleccionado === 'string' && clienteSeleccionado !== 'DEFAULT') {
                clienteIdFinal = clienteSeleccionado;
            }
        }

        const payload = {
            sesion_caja_id: cajaActiva.id,
            bodega_id: cajaActiva?.bodega_id || null,
            cliente_id: clienteIdFinal,
            metodo_pago: metodoPagoActivo,
            efectivo_recibido: (metodoPagoActivo === 'Mixto' || metodoPagoActivo === 'Credito') ? efFijo : (efectivo || 0),
            cambio_entregado: (metodoPagoActivo === 'Mixto' || metodoPagoActivo === 'Credito') ? 0 : cambioEfectivo,
            referencia_pago: (metodoPagoActivo === 'Transferencia' || metodoPagoActivo === 'Mixto') ? digitoComprobante : null,
            banco_destinatario: (metodoPagoActivo === 'Transferencia' || metodoPagoActivo === 'Mixto') ? bancoDestino : null,
            monto_efectivo: efFijo,
            monto_transferencia: trFijo,
            comprobante_img: comprobante,
            total: sumaTotalGlobal,
            items: carrito.map(item => ({
                producto_id: item.es_servicio ? null : (item.producto_id || item.id),
                variante_id: item.variante_id || null,
                cantidad: item.numItems,
                es_servicio: item.es_servicio || false,
                es_combo: item.es_combo || false,
                nombre_servicio: item.es_servicio ? item.nombre : null,
                precio_unitario: item.precioVenta,
                nombre: item.nombre,
                descuento: item.descuento || 0,
                precio_con_descuento: item.precioVenta - ((item.precioVenta * (item.descuento || 0)) / 100),
                precio_original: item.precioPorDefecto || item.precio_original || item.precioVenta,
                precio_editado: item.precio_editado || false,
                precio_compra: item.precio_compra || 0
            }))
        };

        ejecutarVenta(payload, {
            onSuccess: async (data) => {
                if (ordenIdOrigen) {
                    try {
                        const token = await getJwtToken();
                        await axios.put(
                            `${process.env.REACT_APP_API_URL}/v1-ordenes-venta/${ordenIdOrigen}`,
                            { estado: 'completado' },
                            { headers: { Authorization: `Bearer ${token}` } }
                        );
                    } catch (err) {
                        console.error("Error al actualizar estado de la orden de pedido:", err);
                    }
                }
                const infoCliente = clientesDBSeguro.find(c => c.id === clienteIdFinal);
                const datosBase = {
                    carrito: [...carrito],
                    totales: { ...datosTotales },
                    ventaId: data.ventaId,
                    numeroFactura: data.numero_factura,
                    fechaVenta: new Date().toISOString(),
                    clienteNombre: infoCliente ? infoCliente.nombre : 'CONSUMIDOR FINAL',
                    clienteDocumento: infoCliente ? infoCliente.documento : '222222222222',
                    clienteTelefono: infoCliente ? infoCliente.telefono : '',
                    clienteDireccion: infoCliente ? infoCliente.direccion : '',
                    clienteEmail: infoCliente ? infoCliente.email : '',
                    cajero: cajaActiva?.usuario_nombre + ' ' + cajaActiva?.usuario_apellidos || 'Cajero',
                    metodoPago: metodoPagoActivo,
                    efectivoRecibido: (metodoPagoActivo === 'Mixto' || metodoPagoActivo === 'Credito') ? efFijo : (efectivo || sumaTotalGlobal),
                    cambioEntregado: cambioEfectivo,
                    montoTransferencia: trFijo
                };

                if (imprimirTicket) {
                    const tipoImpresora = config?.impresora_tipo || config?.settings?.impresora_tipo;
                    const conexionImpresora = config?.settings?.conexion_impresora || 'sistema';

                    if (tipoImpresora === 'carta_mitad') {
                        const infoNegocio = {
                            nombre: config.nombre, nombre_legal: config.nombre_legal, nit: config.identificacion_fiscal,
                            direccion: config.direccion, telefono: config.telefono, logo_url: config.logo_url
                        };
                        const nuevaPestana = window.open('', '_blank');
                        if (nuevaPestana) nuevaPestana.document.write('Generando PDF, por favor espere...');
                        try {
                            const blob = await pdf(<FacturaFormal {...datosBase} infoNegocio={infoNegocio} />).toBlob();
                            if (nuevaPestana) nuevaPestana.location.href = URL.createObjectURL(blob);
                        } catch (error) {
                            console.error("Error PDF:", error);
                            if (nuevaPestana) nuevaPestana.close();
                        }
                    } else if (conexionImpresora === 'bluetooth') {
                        message.loading({ content: 'Conectando con impresora Bluetooth...', key: 'imprimiendoBT' });
                        await enviarTicketBluetooth(datosBase);
                        message.success({ content: 'Ticket impreso', key: 'imprimiendoBT' });
                    } else {
                        setDatosImpresion(datosBase);
                        setTimeout(() => { handlePrint(); }, 500);
                    }
                }
                setIsSubmitting(false);
                cerrarYLimpiar();
                message.success("Venta procesada con éxito");
            },
            onError: () => {
                setIsSubmitting(false);
                message.error("Error al procesar la venta.")
            }
        });
    };

    const cerrarYLimpiar = () => {
        setIsModalOpen(false);
        setClienteSeleccionado({ id: 'DEFAULT', lista_precio_id: null });
        setListaPrecioActiva('DEFAULT');
        setEfectivo(null);
        setMontoMixtoEfectivo(null);
        setAbonoInicial(null);
        setDigitoComprobante("");
        setMetodoPagoActivo('Efectivo');
        if (ventaActivaEnEspera?.id) deleteEspera.mutate(ventaActivaEnEspera.id);
        setComprobante(null);
        vaciarCarrito();
    };

    const formatCOP = value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const parseCOP = value => value.replace(/\$\s?|(,*)/g, '');

    const touchBtnStyle = { height: '60px', borderRadius: '12px', fontWeight: '700', fontSize: '16px' };
    const touchInputStyle = { height: '60px', borderRadius: '12px', fontSize: '24px', fontWeight: '800', paddingTop: '10px', border: '2px solid #94a3b8' }; // Bordes más fuertes

    const getBillColor = (amount) => {
        if (amount === 10000) return { bg: '#fff1f2', border: '#fda4af', color: '#e11d48' };
        if (amount === 20000) return { bg: '#fff7ed', border: '#fdba74', color: '#ea580c' };
        if (amount === 50000) return { bg: '#f5f3ff', border: '#c4b5fd', color: '#7c3aed' };
        if (amount === 100000) return { bg: '#f0fdf4', border: '#86efac', color: '#16a34a' };
        return { bg: '#f8fafc', border: '#cbd5e1', color: '#0f172a' };
    };

    const enviarTicketBluetooth = async (datosBase) => {
        try {
            if (!navigator.bluetooth) {
                return message.error("Tu dispositivo no soporta conexión Bluetooth directa desde el navegador.");
            }

            // Todos los UUIDs expuestos por SAT y DIGITALPOS
            const serviciosRequeridos = [
                '000018f0-0000-1000-8000-00805f9b34fb', // Impresora SAT (Cliente)
                '0000ff00-0000-1000-8000-00805f9b34fb', // DIGITALPOS (Canal Datos Estándar)
                '0000fee7-0000-1000-8000-00805f9b34fb', // DIGITALPOS (Canal Datos Secundario)
                '49535343-fe7d-41a3-8c53-0be4c0000001'  // DIGITALPOS SPP
            ];

            const device = await navigator.bluetooth.requestDevice({
                acceptAllDevices: true,
                optionalServices: serviciosRequeridos
            });

            const server = await device.gatt.connect();
            let characteristicTarget = null;

            // Recorremos los servicios para encontrar el compatible
            for (const serviceUuid of serviciosRequeridos) {
                try {
                    const service = await server.getPrimaryService(serviceUuid);
                    const characteristics = await service.getCharacteristics();

                    if (characteristics && characteristics.length > 0) {
                        // Buscamos la característica con permisos de escritura
                        characteristicTarget = characteristics.find(c => c.properties.write || c.properties.writeWithoutResponse) || characteristics[0];
                        if (characteristicTarget) {
                            break;
                        }
                    }
                } catch (e) {
                    // Si el servicio no existe en el dispositivo conectado, continúa probando el siguiente
                }
            }

            if (!characteristicTarget) {
                device.gatt.disconnect();
                return message.error("No se encontró una característica válida en la impresora.");
            }

            const infoNegocio = {
                nombre: config.nombre,
                nombre_legal: config.nombre_legal,
                nit: config.identificacion_fiscal,
                direccion: config.direccion,
                telefono: config.telefono
            };

            const tipoPapel = config?.settings?.impresora_tipo || '80mm';
            const payload = generarTicketBluetooth(datosBase, infoNegocio, tipoPapel);

            // MANTENEMOS LOS VALORES ORIGINALES QUE YA FUNCIONAN PARA VENTAS
            const CHUNK_SIZE = 100;

            for (let i = 0; i < payload.length; i += CHUNK_SIZE) {
                const chunk = payload.slice(i, i + CHUNK_SIZE);

                try {
                    await characteristicTarget.writeValue(chunk);
                } catch (errWrite) {
                    await characteristicTarget.writeValueWithoutResponse(chunk);
                }

                // Mantenemos el timeout de 150ms original
                await new Promise(resolve => setTimeout(resolve, 150));
            }

            device.gatt.disconnect();

        } catch (error) {
            console.error("Error al imprimir por Bluetooth:", error);
            message.error("Falló la impresión. Verifica que la impresora esté encendida y cerca.");
        }
    };

    return (
        <Modal
            title={null}
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            width={950}
            centered
            closable={false}
            footer={null}
            styles={{
                body: { padding: '2px 12px', maxHeight: '92vh', overflowY: 'auto' }, mask: {
                    backgroundColor: 'rgba(15, 23, 42, 0.85)',
                    backdropFilter: 'blur(4px)',
                    WebkitBackdropFilter: 'blur(4px)'
                }
            }}
        >
            {/* HEADER CUSTOM */}
            <div style={{
                display: 'flex',
                justify: 'space-between',
                alignItems: 'center',
                marginBottom: '12px',
                paddingBottom: '10px',
                borderBottom: '2px solid #cbd5e1',
                gap: '8px'
            }}>
                <Space size={isMobile ? 8 : 12} style={{ flex: 1, minWidth: 0 }}>
                    <div style={{
                        background: '#ccfbf1',
                        padding: isMobile ? '8px' : '10px',
                        borderRadius: '12px',
                        border: '1px solid #14b8a6',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}>
                        <ThunderboltOutlined style={{ color: '#0f766e', fontSize: isMobile ? '18px' : '24px' }} />
                    </div>
                    <Title level={4} style={{
                        margin: 0,
                        color: '#0f172a',
                        fontWeight: '900',
                        fontSize: isMobile ? '16px' : '22px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>
                        Confirmar Pago
                    </Title>
                </Space>

                <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <Text type="secondary" style={{
                        fontSize: isMobile ? '10px' : '13px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        display: 'block',
                        marginBottom: '0px',
                        fontWeight: '800',
                        color: '#475569',
                        whiteSpace: 'nowrap'
                    }}>
                        Total a Cobrar
                    </Text>
                    <Text strong style={{
                        fontSize: isMobile ? '22px' : '36px',
                        color: '#e11d48',
                        fontWeight: '900',
                        fontFamily: 'nunito',
                        whiteSpace: 'nowrap',
                        lineHeight: 1.1
                    }}>
                        ${sumaTotalGlobal.toLocaleString('es-CO')}
                    </Text>
                </div>
            </div>

            <Row gutter={[32, 24]}>
                {/* COLUMNA IZQUIERDA: MÉTODOS DE PAGO */}
                <Col xs={24} md={14} order={isMobile ? 2 : 1}>
                    <Text strong style={{ fontSize: '18px', color: '#0f172a', marginBottom: '8px', display: 'block', fontWeight: '800' }}>Método de Pago</Text>

                    <Row gutter={[12, 12]}>
                        {[
                            { id: 'Efectivo', label: 'Efectivo', icon: <DollarOutlined /> },
                            { id: 'Transferencia', label: isMobile ? 'Transf.' : 'Transferencia', icon: <SwapOutlined /> },
                            { id: 'Mixto', label: 'Mixto', icon: <PieChartOutlined /> },
                            { id: 'Credito', label: 'Crédito', icon: <SolutionOutlined /> }
                        ].map(m => (
                            <Col span={12} key={m.id}>
                                <Button
                                    block
                                    onClick={() => setMetodoPagoActivo(m.id)}
                                    style={{
                                        ...touchBtnStyle,
                                        fontSize: isMobile ? '14px' : '18px',
                                        padding: isMobile ? '0 4px' : '4px 15px',
                                        background: metodoPagoActivo === m.id ? '#0d9488' : '#ffffff',
                                        color: metodoPagoActivo === m.id ? '#fff' : '#334155',
                                        border: metodoPagoActivo === m.id ? '2px solid #0f766e' : '2px solid #cbd5e1',
                                        boxShadow: metodoPagoActivo === m.id ? '0 4px 6px -1px rgba(13, 148, 136, 0.2)' : 'none'
                                    }}
                                >
                                    <Space size={isMobile ? "small" : "middle"}>
                                        {m.icon}
                                        <span style={{ whiteSpace: 'nowrap' }}>{m.label}</span>
                                    </Space>
                                </Button>
                            </Col>
                        ))}
                    </Row>

                    {/* ÁREA DINÁMICA DE COBRO */}
                    <div style={{ marginTop: '24px', padding: '20px', background: '#f1f5f9', borderRadius: '16px', border: '2px solid #cbd5e1', minHeight: '220px' }}>

                        {metodoPagoActivo === 'Efectivo' && (
                            <div className="fade-in">
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Text strong style={{ fontSize: '15px', color: '#334155' }}>Recibido del cliente</Text>
                                        <InputNumber
                                            ref={inputEfectivoRef}
                                            controls={false}
                                            precision={0}
                                            style={{ width: '100%', marginTop: '8px' }}
                                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                                            value={efectivo}
                                            onChange={setEfectivo}
                                        />
                                    </Col>
                                    <Col span={12}>
                                        <Text strong style={{ fontSize: '15px', color: '#334155' }}>Cambio (Vuelto)</Text>
                                        <div style={{
                                            height: '60px', background: cambioEfectivo > 0 ? '#dcfce3' : '#e2e8f0', borderRadius: '12px',
                                            border: cambioEfectivo > 0 ? '2px solid #16a34a' : '2px solid #94a3b8', marginTop: '8px',
                                            display: 'flex', alignItems: 'center', padding: '0 20px', fontSize: '24px', fontWeight: '900',
                                            color: cambioEfectivo > 0 ? '#15803d' : '#475569'
                                        }}>
                                            $ {cambioEfectivo.toLocaleString('es-CO')}
                                        </div>
                                    </Col>
                                </Row>

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '20px' }}>
                                    <Button
                                        type="dashed" onClick={() => setEfectivo(sumaTotalGlobal)}
                                        style={{ ...touchBtnStyle, flex: '1 1 100%', background: '#ccfbf1', borderColor: '#0d9488', color: '#0f766e', fontSize: '18px', borderStyle: 'solid', borderWidth: '2px' }}
                                    >
                                        Exacto: ${sumaTotalGlobal.toLocaleString('es-CO')}
                                    </Button>

                                    {(() => {
                                        const sugerencias = [];
                                        const billetes = [10000, 20000, 50000, 100000];
                                        billetes.forEach(b => {
                                            if (b > sumaTotalGlobal) sugerencias.push(b);
                                            else { let m = b; while (m <= sumaTotalGlobal) m += b; if (m <= sumaTotalGlobal * 2) sugerencias.push(m); }
                                        });

                                        const finalSuggestions = [...new Set(sugerencias)].sort((a, b) => a - b).slice(0, 3);

                                        return finalSuggestions.map(valor => {
                                            const colors = getBillColor(valor);
                                            return (
                                                <Button
                                                    key={valor}
                                                    onClick={() => setEfectivo(valor)}
                                                    style={{
                                                        ...touchBtnStyle,
                                                        flex: 1,
                                                        fontSize: '18px',
                                                        background: colors.bg,
                                                        borderColor: colors.border,
                                                        color: colors.color,
                                                        borderWidth: '2px'
                                                    }}
                                                >
                                                    ${valor.toLocaleString('es-CO')}
                                                </Button>
                                            );
                                        });
                                    })()}
                                </div>
                            </div>
                        )}

                        {metodoPagoActivo === 'Transferencia' && (
                            <div className="fade-in">
                                <Row gutter={[12, 12]}>
                                    {/* GRID 3x2 DE LOS 6 BANCOS DESTINO */}
                                    <Col span={24}>
                                        <Text strong style={{ fontSize: '13px', color: '#334155', display: 'block', marginBottom: '8px' }}>
                                            Selecciona el Medio / Banco Destino:
                                        </Text>
                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(3, 1fr)',
                                            gap: '8px'
                                        }}>
                                            {OPCIONES_BANCOS.map(b => {
                                                const esSeleccionado = bancoDestino === b.id;
                                                return (
                                                    <button
                                                        key={b.id}
                                                        type="button"
                                                        onClick={() => setBancoDestino(b.id)}
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            height: isMobile ? '60px' : '70px',
                                                            borderRadius: '12px',
                                                            border: esSeleccionado ? `2.5px solid ${b.color}` : '2px solid #cbd5e1',
                                                            backgroundColor: esSeleccionado ? b.bg : '#ffffff',
                                                            color: esSeleccionado ? b.color : '#475569',
                                                            fontWeight: esSeleccionado ? '800' : '600',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.15s ease',
                                                            boxShadow: esSeleccionado ? `0 4px 10px ${b.border}` : 'none',
                                                            outline: 'none',
                                                            padding: '4px'
                                                        }}
                                                    >
                                                        <span style={{ fontSize: isMobile ? '18px' : '22px', marginBottom: '2px' }}>{b.icon}</span>
                                                        <span style={{ fontSize: isMobile ? '11px' : '12px', textAlign: 'center', lineHeight: '1.1' }}>
                                                            {b.label}
                                                        </span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </Col>

                                    {/* MISMA FILA: REFERENCIA (IZQ) Y FOTO SOPORTE (DER) */}
                                    <Col xs={14} sm={15}>
                                        <Text strong style={{ fontSize: '12px', color: '#334155', display: 'block', marginBottom: '4px' }}>
                                            Ref. / Comprobante
                                        </Text>
                                        <Input
                                            placeholder="Ej. 9012"
                                            maxLength={10}
                                            value={digitoComprobante}
                                            onChange={(e) => setDigitoComprobante(e.target.value)}
                                            style={{
                                                ...touchInputStyle,
                                                height: isMobile ? '48px' : '52px',
                                                paddingTop: '0',
                                                fontSize: isMobile ? '16px' : '18px',
                                                borderRadius: '10px'
                                            }}
                                        />
                                    </Col>

                                    <Col xs={10} sm={9}>
                                        <Text strong style={{ fontSize: '12px', color: '#334155', display: 'block', marginBottom: '4px' }}>
                                            Soporte Foto
                                        </Text>
                                        {comprobante ? (
                                            <div style={{
                                                height: isMobile ? '48px' : '52px',
                                                borderRadius: '10px',
                                                border: '2px solid #0d9488',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}>
                                                <img src={comprobante} alt="Soporte" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                <Button
                                                    danger
                                                    type="primary"
                                                    shape="circle"
                                                    icon={<DeleteOutlined />}
                                                    size="small"
                                                    style={{ position: 'absolute', top: 2, right: 2, transform: 'scale(0.7)' }}
                                                    onClick={() => setComprobante(null)}
                                                />
                                            </div>
                                        ) : (
                                            <Upload
                                                accept="image/*"
                                                showUploadList={false}
                                                beforeUpload={(file) => {
                                                    const reader = new FileReader();
                                                    reader.onload = (e) => setComprobante(e.target.result);
                                                    reader.readAsDataURL(file);
                                                    return false;
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '6px',
                                                        height: isMobile ? '48px' : '52px',
                                                        width: '100%',
                                                        borderRadius: '10px',
                                                        border: '2px dashed #0d9488',
                                                        backgroundColor: '#ccfbf1',
                                                        color: '#0f766e',
                                                        fontWeight: '700',
                                                        cursor: 'pointer',
                                                        outline: 'none',
                                                        padding: '0 8px'
                                                    }}
                                                >
                                                    <CameraOutlined style={{ fontSize: isMobile ? '18px' : '20px' }} />
                                                    <span style={{ fontSize: isMobile ? '11px' : '12px', whiteSpace: 'nowrap' }}>
                                                        Foto
                                                    </span>
                                                </button>
                                            </Upload>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {metodoPagoActivo === 'Mixto' && (
                            <div className="fade-in">
                                <Row gutter={[12, 12]}>
                                    <Col span={12}>
                                        <Text strong style={{ fontSize: '13px', color: '#334155' }}>Efectivo Recibido</Text>
                                        <InputNumber controls={false} autoFocus style={{ width: '100%', marginTop: '4px' }} formatter={formatCOP} parser={parseCOP} value={montoMixtoEfectivo} onChange={setMontoMixtoEfectivo} />
                                    </Col>
                                    <Col span={12}>
                                        <Text strong style={{ fontSize: '13px', color: '#334155' }}>Falta por transferir</Text>
                                        <div style={{ height: '60px', background: '#fff', borderRadius: '12px', border: '2px solid #059669', marginTop: '4px', display: 'flex', alignItems: 'center', padding: isMobile ? '0 10px' : '0 15px', fontSize: isMobile ? '16px' : '20px', fontWeight: '900', color: '#059669' }}>
                                            $ {montoMixtoCalculado.toLocaleString('es-CO')}
                                        </div>
                                    </Col>

                                    {/* SELECCIÓN CUADRADA DE MEDIO DE PAGO EN MIXTO */}
                                    <Col span={24}>
                                        <Text strong style={{ fontSize: '12px', color: '#334155', display: 'block', marginBottom: '6px' }}>
                                            Transferir saldo a:
                                        </Text>
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px' }}>
                                            {OPCIONES_BANCOS.map(b => {
                                                const esSeleccionado = bancoDestino === b.id;
                                                return (
                                                    <button
                                                        key={b.id}
                                                        type="button"
                                                        onClick={() => setBancoDestino(b.id)}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '6px',
                                                            height: '45px',
                                                            borderRadius: '8px',
                                                            border: esSeleccionado ? `2px solid ${b.color}` : '1px solid #cbd5e1',
                                                            backgroundColor: esSeleccionado ? b.bg : '#ffffff',
                                                            color: esSeleccionado ? b.color : '#475569',
                                                            fontWeight: esSeleccionado ? '800' : '600',
                                                            fontSize: '11px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        <span>{b.icon}</span>
                                                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{b.label}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    </Col>

                                    {/* FILA INFERIOR: REFERENCIA (IZQ) Y FOTO DE SOPORTE (DER) */}
                                    <Col xs={14} sm={15}>
                                        <Text strong style={{ fontSize: '12px', color: '#334155', display: 'block', marginBottom: '4px' }}>
                                            Ref. / Comprobante
                                        </Text>
                                        <Input
                                            placeholder="Ej. 9012"
                                            maxLength={10}
                                            value={digitoComprobante}
                                            onChange={(e) => setDigitoComprobante(e.target.value)}
                                            style={{
                                                ...touchInputStyle,
                                                height: isMobile ? '48px' : '52px',
                                                paddingTop: '0',
                                                fontSize: isMobile ? '16px' : '18px',
                                                borderRadius: '10px'
                                            }}
                                        />
                                    </Col>

                                    <Col xs={10} sm={9}>
                                        <Text strong style={{ fontSize: '12px', color: '#334155', display: 'block', marginBottom: '4px' }}>
                                            Soporte Foto
                                        </Text>
                                        {comprobante ? (
                                            <div style={{
                                                height: isMobile ? '48px' : '52px',
                                                borderRadius: '10px',
                                                border: '2px solid #0d9488',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}>
                                                <img src={comprobante} alt="Soporte" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                <Button
                                                    danger
                                                    type="primary"
                                                    shape="circle"
                                                    icon={<DeleteOutlined />}
                                                    size="small"
                                                    style={{ position: 'absolute', top: 2, right: 2, transform: 'scale(0.7)' }}
                                                    onClick={() => setComprobante(null)}
                                                />
                                            </div>
                                        ) : (
                                            <Upload
                                                accept="image/*"
                                                showUploadList={false}
                                                beforeUpload={(file) => {
                                                    const reader = new FileReader();
                                                    reader.onload = (e) => setComprobante(e.target.result);
                                                    reader.readAsDataURL(file);
                                                    return false;
                                                }}
                                            >
                                                <button
                                                    type="button"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        gap: '6px',
                                                        height: isMobile ? '48px' : '52px',
                                                        width: '100%',
                                                        borderRadius: '10px',
                                                        border: '2px dashed #0d9488',
                                                        backgroundColor: '#ccfbf1',
                                                        color: '#0f766e',
                                                        fontWeight: '700',
                                                        cursor: 'pointer',
                                                        outline: 'none',
                                                        padding: '0 8px'
                                                    }}
                                                >
                                                    <CameraOutlined style={{ fontSize: isMobile ? '18px' : '20px' }} />
                                                    <span style={{ fontSize: isMobile ? '11px' : '12px', whiteSpace: 'nowrap' }}>
                                                        Foto
                                                    </span>
                                                </button>
                                            </Upload>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        )}

                        {metodoPagoActivo === 'Credito' && (
                            <div className="fade-in">
                                <Alert message={<Text strong style={{ color: '#9a3412', fontSize: '16px' }}>Venta a Crédito (Fiado)</Text>} description="La deuda se asignará al cliente seleccionado en el panel derecho." type="warning" showIcon style={{ padding: '16px', borderRadius: '12px', backgroundColor: '#fff7ed', border: '2px solid #ea580c' }} />
                                <div style={{ marginTop: '20px' }}>
                                    <Text strong style={{ fontSize: '15px', color: '#334155' }}>Abono inicial en efectivo (Opcional)</Text>
                                    <InputNumber controls={false} style={{ width: '100%', marginTop: '8px' }} formatter={formatCOP} parser={parseCOP} value={abonoInicial} onChange={setAbonoInicial} />
                                </div>
                            </div>
                        )}

                    </div>

                    {/* EN MÓVIL: SE RENDERIZA AQUÍ ABAJO DE MÉTODOS DE PAGO */}
                    {isMobile && (
                        <div style={{ marginTop: '16px' }}>
                            <Text strong style={{ fontSize: '18px', color: '#0f172a', marginBottom: '6px', display: 'block', fontWeight: '800' }}>Imprimir Recibo</Text>
                            <div style={{ marginTop: '8px', background: imprimirTicket ? '#f0fdf4' : '#f8fafc', padding: '20px', borderRadius: '16px', border: imprimirTicket ? '2px solid #22c55e' : '2px solid #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'all 0.3s ease' }}>
                                <Space>
                                    <div style={{ background: imprimirTicket ? '#16a34a' : '#94a3b8', padding: '12px', borderRadius: '50%', color: '#fff', display: 'flex', transition: 'all 0.3s ease' }}>
                                        <PrinterOutlined style={{ fontSize: '24px' }} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Text type="secondary" style={{ fontSize: '14px', fontWeight: '600', color: '#0f172a' }}>Entregar copia al cliente</Text>
                                    </div>
                                </Space>
                                <div style={{ display: 'flex', gap: '5px', background: '#e2e8f0', padding: '4px', borderRadius: '12px' }}>
                                    <Button
                                        onClick={() => setImprimirTicket(false)}
                                        style={{ flex: 1, border: 'none', background: !imprimirTicket ? '#ef4444' : 'transparent', color: !imprimirTicket ? '#fff' : '#64748b', fontWeight: 'bold' }}>
                                        NO
                                    </Button>
                                    <Button
                                        onClick={() => setImprimirTicket(true)}
                                        style={{ flex: 1, border: 'none', background: imprimirTicket ? '#22c55e' : 'transparent', color: imprimirTicket ? '#fff' : '#64748b', fontWeight: 'bold' }}>
                                        SÍ
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Col>

                {/* COLUMNA DERECHA: CLIENTE E IMPRESIÓN */}
                <Col xs={24} md={10} order={isMobile ? 1 : 2}>
                    <Text strong style={{ fontSize: '18px', color: '#0f172a', marginBottom: '8px', display: 'block', fontWeight: '800' }}>Cliente e Impresión</Text>

                    {/* TARJETA DE CLIENTE */}
                    <div className='tarjeta-cliente' style={{ background: '#f8fafc', border: '2px solid #cbd5e1', borderRadius: '16px', padding: '24px', height: 'auto', display: 'flex', flexDirection: 'column' }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                            <Space>
                                <div style={{ background: '#334155', padding: '8px', borderRadius: '50%', color: '#fff', display: 'flex' }}><IdcardOutlined style={{ fontSize: '20px' }} /></div>
                                <Text strong style={{ fontSize: '16px', color: '#0f172a' }}>Asignar Venta a:</Text>
                            </Space>
                            {metodoPagoActivo === 'Credito' && (!clienteSeleccionado || clienteSeleccionado === 'DEFAULT') && (
                                <Tag color="error" style={{ border: '1px solid #ef4444', fontWeight: 'bold' }}>Obligatorio</Tag>
                            )}
                        </div>

                        <Select
                            showSearch
                            style={{ width: '100%', marginBottom: '16px', height: '60px' }}
                            className="select-grande"
                            value={clienteSeleccionado?.id || clienteSeleccionado}
                            onChange={(val) => {
                                const clienteEncontrado = clientesDBSeguro.find(c => c.id === val);

                                if (!val || val === 'DEFAULT') {
                                    setClienteSeleccionado({ id: 'DEFAULT', lista_precio_id: null });
                                } else {
                                    setClienteSeleccionado({
                                        id: val,
                                        lista_precio_id: clienteEncontrado?.lista_precio_id || null
                                    });
                                }
                            }}
                            placeholder="🔎 Buscar Nombre o NIT..."
                            options={[
                                { value: 'DEFAULT', label: 'Consumidor Final', documento: '222222222222', esDefault: true },
                                ...clientesDBSeguro.map(c => ({ value: c.id, label: `${c.documento || 'S/N'} - ${c.nombre}`, nombre: c.nombre, documento: c.documento, esDefault: false }))
                            ]}
                            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                            optionRender={(option) => (
                                <div style={{ display: 'flex', flexDirection: 'column', padding: '6px 0' }}>
                                    <Text strong style={{ color: option.data.esDefault ? '#0d9488' : '#0f172a', fontSize: '15px' }}>{option.data.esDefault ? '🛒 ' + option.data.label : option.data.nombre}</Text>
                                    <Text type="secondary" style={{ fontSize: '13px', color: '#475569' }}>NIT/CC: {option.data.documento || 'No registrado'}</Text>
                                </div>
                            )}
                        />

                        {(() => {
                            const clienteSeleccionadoData = clientesDBSeguro.find(c => c.id === clienteSeleccionado);
                            if (clienteSeleccionadoData?.lista_precio_id) {
                                const nombresListas = {
                                    lista_1: config?.config_tarifas?.lista_1?.nombre || 'Precio Lista 1',
                                    lista_2: config?.config_tarifas?.lista_2?.nombre || 'Precio Lista 2',
                                    lista_3: config?.config_tarifas?.lista_3?.nombre || 'Precio Lista 3'
                                };
                                const nombreAplicado = nombresListas[clienteSeleccionadoData.lista_precio_id] || 'Precio Especial';
                                return (
                                    <div style={{ marginBottom: '16px', marginTop: '-8px' }}>
                                        <Tag color="green" style={{ fontSize: '13px', padding: '4px 10px', borderRadius: '6px', border: '1px solid #4ade80' }}>
                                            ✓ <b>{nombreAplicado}</b> aplicado automáticamente
                                        </Tag>
                                    </div>
                                );
                            }
                            return null;
                        })()}

                        <Button type="dashed" block icon={<UserOutlined />} onClick={() => setIsModalClienteOpen(true)} style={{ ...touchBtnStyle, color: '#0f172a', borderColor: '#94a3b8', background: '#fff', borderWidth: '2px' }}>
                            Crear Nuevo Cliente
                        </Button>
                    </div>

                    {/* EN ESCRITORIO (WEB): SE RENDERIZA AQUÍ ABAJO DE CLIENTE */}
                    {!isMobile && (
                        <div>
                            <Text strong style={{ fontSize: '18px', color: '#0f172a', marginBottom: '6px', marginTop: '15px', display: 'block', fontWeight: '800' }}>Imprimir Recibo</Text>
                            <div style={{ marginTop: '8px', background: imprimirTicket ? '#f0fdf4' : '#f8fafc', padding: '20px', borderRadius: '16px', border: imprimirTicket ? '2px solid #22c55e' : '2px solid #cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'all 0.3s ease' }}>
                                <Space>
                                    <div style={{ background: imprimirTicket ? '#16a34a' : '#94a3b8', padding: '12px', borderRadius: '50%', color: '#fff', display: 'flex', transition: 'all 0.3s ease' }}>
                                        <PrinterOutlined style={{ fontSize: '24px' }} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <Text type="secondary" style={{ fontSize: '14px', fontWeight: '600', color: '#0f172a' }}>Entregar copia al cliente</Text>
                                    </div>
                                </Space>
                                <div style={{ display: 'flex', gap: '5px', background: '#e2e8f0', padding: '4px', borderRadius: '12px' }}>
                                    <Button
                                        onClick={() => setImprimirTicket(false)}
                                        style={{ flex: 1, border: 'none', background: !imprimirTicket ? '#ef4444' : 'transparent', color: !imprimirTicket ? '#fff' : '#64748b', fontWeight: 'bold' }}>
                                        NO
                                    </Button>
                                    <Button
                                        onClick={() => setImprimirTicket(true)}
                                        style={{ flex: 1, border: 'none', background: imprimirTicket ? '#22c55e' : 'transparent', color: imprimirTicket ? '#fff' : '#64748b', fontWeight: 'bold' }}>
                                        SÍ
                                    </Button>
                                </div>
                            </div>
                        </div>
                    )}
                </Col>
            </Row>

            {/* FOOTER DE ACCIONES GIGANTES */}
            <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column-reverse' : 'row',
                gap: '16px',
                marginTop: '32px',
                paddingTop: '24px',
                borderTop: '2px solid #cbd5e1'
            }}>
                <Button size="large" onClick={() => setIsModalOpen(false)} style={{ ...touchBtnStyle, flex: 1, height: isMobile ? '55px' : '65px', fontSize: '18px', background: '#e2e8f0', color: '#0f172a', borderColor: '#cbd5e1', borderWidth: '2px', width: '100%' }}>
                    CANCELAR
                </Button>
                <Button type="primary" loading={procesandoVenta || isSubmitting} onClick={cobrarVenta} style={{ ...touchBtnStyle, flex: 2, height: isMobile ? '60px' : '65px', fontSize: isMobile ? '18px' : '22px', fontWeight: '900', background: '#0d9488', borderColor: '#0d9488', width: '100%' }}>
                    CONFIRMAR COBRO
                </Button>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
                /* Ajuste para el InputNumber: Centrado total */
                .ant-input-number {
                    display: flex !important;
                    align-items: center !important;
                    height: 60px !important;
                    border-radius: 12px !important;
                    border: 2px solid #94a3b8 !important;
                }
                .ant-input-number-input {
                    font-size: 24px !important;
                    font-weight: 800 !important;
                    height: 60px !important;
                    paddingLeft: 6px !important; /* Quitamos el padding que desalineaba */
                    line-height: 60px !important; /* Fuerza el centrado vertical */
                }

                /* Resto de estilos */
                .select-grande .ant-select-selector { height: 60px !important; align-items: center; border-radius: 12px !important; font-size: 18px !important; font-weight: 700 !important; border: 2px solid #94a3b8 !important; }
                .select-grande .ant-select-selection-item { line-height: 56px !important; color: #0f172a !important; }
                .select-grande .ant-select-selection-placeholder { line-height: 56px !important; color: #64748b !important; font-weight: 600 !important; }
                
                input::-webkit-outer-spin-button,
                input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
                input[type=number] { -moz-appearance: textfield; }
            `}} />
        </Modal>
    )
}

export default ModalCobrar;